import React, { forwardRef, useLayoutEffect, useRef } from 'react';

export function lazyAdapter(getLazyComponent) {
  let componentModule = {
    status: 'pending',
    promise: null,
    result: null,
  };

  const Wrapper = forwardRef((props, ref) => {
    const createRoot = readModule(componentModule, getLazyComponent).default;
    const containerRef = useRef(null);
    const rootRef = useRef(null);

    // Create/unmount.
    useLayoutEffect(() => {
      if (!rootRef.current) {
        rootRef.current = createRoot(containerRef.current);
      }
      const root = rootRef.current;
      return () => {
        root.unmount();
      };
    }, [createRoot]);

    // Mount/update.
    useLayoutEffect(() => {
      if (rootRef.current) {
        rootRef.current.render(props, ref);
      }
    }, [props, ref]);

    return <div ref={containerRef} />;
  });

  Wrapper.displayName = 'Federation Wrapper';
  return Wrapper;
}

function readModule(record, createPromise) {
  if (record.status === 'fulfilled') {
    return record.result;
  }
  if (record.status === 'rejected') {
    throw record.result;
  }
  if (!record.promise) {
    record.promise = createPromise().then(
      (value) => {
        if (record.status === 'pending') {
          record.status = 'fulfilled';
          record.promise = null;
          record.result = value;
        }
      },
      (error) => {
        if (record.status === 'pending') {
          record.status = 'rejected';
          record.promise = null;
          record.result = error;
        }
      }
    );
  }
  throw record.promise;
}
